module.exports = require("base64-js");


//////////////////
// WEBPACK FOOTER
// external "base64-js"
// module id = 383
// module chunks = 0